export const CREATE_APPOINTMENT = '/create_appointment';
export const PAYMENT = '/payment';